export default __webpack_public_path__ + "static/media/registration_success.fecb7cd8.png";